import React from 'react'

// Branded page shell in the Home design language: soft emerald->teal gradient
// ground, centered mobile-first column, ambient depth. The base of every
// screen in the lease-review journey so the whole flow is visually consistent.
export function Screen({ children, className = '' }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50 dark:from-emerald-900 dark:via-green-900 dark:to-teal-900">
      <div className={`relative mx-auto max-w-md px-6 py-12 ${className}`}>
        <div className="pointer-events-none absolute -left-16 top-16 -z-10 h-56 w-56 rounded-full bg-emerald-400/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-16 bottom-24 -z-10 h-56 w-56 rounded-full bg-teal-400/10 blur-3xl" />
        {children}
      </div>
    </div>
  )
}

export default Screen
